export default __webpack_public_path__ + "static/show-practice-b6078170fe7f20826dc24c777f52f235.svg";